define(['underscore'], (_)=> {
    return ['ModalService', '$filter', '$state', 'state_plugin_config','$stateParams', (ModalService, $filter, $state, statePluginConfig,$stateParams)=> {

        function handleEntityExceptionAtQuote(error,model){
    const message = $filter('translate')('integration.quoteandbind.directives.ErrorHandling.An Error Occured While Quoting');
    var errorMsg = '';
    if(error) {
        errorMsg = error;
        var replacementText = '<br>&#9679;&nbsp;';
        errorMsg = formatMessage(errorMsg,replacementText);
        errorMsg = errorMsg.replace(/;/g, '');
        errorMsg = removeDuplicates(errorMsg,'<br>&#9679&nbsp');
        model.draftData.lobs.value.exception = errorMsg;
        //ModalService.showError(message, errorMsg);
        //model.draftData.lobs.value.exception = errorMsg;
        //var promise = ModalService.showError(message, errorMsg);
        //return 'paVehicleDetails'; //INC0017332-mail from kelsey to go to contact page
        //ENHC0012054- Property / Update Eligibility for Protection Class 10 and 10W - adding error msg to display in contact us page - Arpita
        if(errorMsg.indexOf('Protection Class Code') >= 0)
            {            
                $stateParams.errorMsg = errorMsg;
            }        //ended
        return 'error';

    }else{
        return 'error';
    }

}
    function removeDuplicates(msg,text){
         var msgArray = msg.split(text);
         if(msgArray.length === 1)
            return msg;
         const unique = [...new Set(msgArray)];
         var modifiedMsg = '';
         for(var count = 0;count < unique.length;count++){
           if(unique[count].trim() !== ''){
                modifiedMsg =  modifiedMsg + text + unique[count];
            }
         }
         return modifiedMsg;

    }

    function handleEntityExceptionAtBind(error,model){
        var errorMsg = '';
        if(error) {
            errorMsg = error;
            var replacementText = '<br>';
            errorMsg = formatMessage(errorMsg,replacementText);
            errorMsg = errorMsg.startsWith("<br>")?errorMsg.substring(4):errorMsg;
            errorMsg = errorMsg.replace(/;/g, '');
            model.draftData.lobs.value.exception = errorMsg
        }
        return 'error';
    }

    function handleUWException(error,model){
        var errorMsg = error;
        if(errorMsg) {
            if (errorMsg.indexOf('UnderwritingException') > -1) {
                errorMsg = errorMsg.replace(/edge.capabilities.quote.quoting.exception.UnderwritingException:/g, '');
            }
            if (errorMsg.indexOf('UWIssue') > -1) {
                errorMsg = errorMsg.replace(/UWIssue:/g, '');
            }
            errorMsg = errorMsg.replace(/\n/g, '<br />');
            //UW issues not to be shown to user INC0017332 ex: slavage title
            //model.draftData.lobs.value.exception = errorMsg;
        }
        return 'error'
    }

    function formatMessage(errorMsg,replacementText){

        if (errorMsg.indexOf('PersonalVehicleCov') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PersonalVehicleCov\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PersonalVehicleCov\//g, replacementText);
        }
        if (errorMsg.indexOf('PolicyLine') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PolicyLine\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PolicyLine\//g, replacementText);
        }
        if (errorMsg.indexOf('PolicyPeriod') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PolicyPeriod\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PolicyPeriod\//g, replacementText);
        }
        if (errorMsg.indexOf('PolicyLocation') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PolicyLocation\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PolicyLocation\//g, replacementText);
        }
        if (errorMsg.indexOf('PARiskAnalysis') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PARiskAnalysis\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PARiskAnalysis\//g, replacementText);
        }
        if (errorMsg.indexOf('PersonalVehicle') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PersonalVehicle\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PersonalVehicle\//g, replacementText);
            errorMsg = errorMsg.replace(/error:entity.PersonalVehicle.BodyType\//g, replacementText);
        }
        if (errorMsg.indexOf('PAPolicyInfo') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PAPolicyInfo\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PAPolicyInfo\//g, replacementText);
        }
        if (errorMsg.indexOf('PALineCoverages') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PALineCoverages\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PALineCoverages\//g, replacementText);
        }
        if (errorMsg.indexOf('PALine') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PALine\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PALine\//g, replacementText);
        }
        if (errorMsg.indexOf('PALineAssignment') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PALineAssignment\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PALineAssignment\//g, replacementText);
        }
        if (errorMsg.indexOf('PALineDrivers') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PALineDrivers\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PALineDrivers\//g, replacementText);
        }
        if (errorMsg.indexOf('PALineVehicles') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PALineVehicles\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PALineVehicles\//g, replacementText);
        }
        if (errorMsg.indexOf('PersonalAutoLine') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PersonalAutoLine\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PersonalAutoLine\//g, replacementText);
        }
        if (errorMsg.indexOf('PersonalAutoCov') > -1) {
            errorMsg = errorMsg.replace(/error:entity.PersonalAutoCov\//g, replacementText);
            errorMsg = errorMsg.replace(/warning:entity.PersonalAutoCov\//g, replacementText);
        }

        return errorMsg;
    }


    return {
            checkSessionUUID: (submissionDTO, deferred)=> {
            if (submissionDTO === undefined || submissionDTO.sessionUUID === null || submissionDTO.sessionUUID === '') { // If a session UUID wasn't created, reject with an error message
        return deferred.reject('Error creating quote');
    }
    },

    getQuoteExceptionHandler: (exception,model)=> {
        var message = null;
        var error = exception.error;
        if(error.constructor == Array && error.length > 0 && error[0].baseError && error[0].baseError.data  &&
            error[0].baseError.data.error && error[0].baseError.data.error.message != undefined ) {
            message = error[0].baseError.data.error.message;
        }
        if(message && message.indexOf('entity') > -1){
            return handleEntityExceptionAtQuote(message, model);
        }else if(message && message.indexOf('UWIssue') > -1){
            return handleUWException(message, model);
        }else{
            return 'error';
        }
    },

    getBindExceptionHandler: (exception,model)=> {
        var message = null;
        var error = exception.error;
        if(error.constructor == Array && error.length > 0 && error[0].baseError && error[0].baseError.data  &&
            error[0].baseError.data.error && error[0].baseError.data.error.message != undefined ) {
            message = error[0].baseError.data.error.message;
        }
        if(message && message.indexOf('entity') > -1){
            return handleEntityExceptionAtBind(message,model);
        }//added else if block for Underwriting issues for incident: INC0020671 by IN010M58288
        else if(message && (message.indexOf('UWIssue') > -1 || message.indexOf('UnderwritingException') > -1)){
            return handleUWException(message, model);
        }else{
            return 'error';
        }
    },

    getVehicleAgeValidated: (vehicle, customQuote)=> {
         var vehicleYear =  vehicle.year;
         var vehicleName =  vehicleYear +" "+ vehicle.make+" " + vehicle.model+" ";
         var vehicleId = vehicle.publicID;
         var vehicleCovs = _.where(customQuote[0].lobs.personalAuto.vehicleCoverages, {publicID: vehicleId});
         var today = new Date();
         var year = today.getFullYear();
         var errorMsg = '';

         if((parseInt(year) >= (parseInt(vehicleYear)+20)) &&(vehicleCovs[0].coverages.length == 0 ||
                  vehicleCovs[0].coverages.find(function(x){return x.publicID == "PAComprehensiveCov"}) === undefined)){
            var message = $filter('translate')('quoteandbind.controllers.ModalService.Attention');
            errorMsg = $filter('translate')('quoteandbind.views.quote-details.vehicleIneligibleAgePart1')+vehicleName+
            $filter('translate')('quoteandbind.views.quote-details.vehicleIneligibleAgePart2');
         }
         return errorMsg;
    },

    isDisplayError: (errorMsg)=> {
        var remPhysicalDamageCoverage = 'please remove physical damage coverages'
        if (errorMsg.indexOf(remPhysicalDamageCoverage) > -1) {
            return true;
        }
        return false;
    }

    /*,

    checkVehicleOutOfState: (vehicle, customQuote)=> {
             var vehicleYear =  vehicle.year;
             var vehicleName = vehicle.make +" "+ vehicle.model+" " + vehicleYear;
             var vehicleId = vehicle.publicID;
             var vehicleGarageState =  vehicle.parkedState;
             var vehicleCovs = _.where(customQuote[0].lobs.personalAuto.vehicleCoverages, {publicID: vehicleId});
             var errorMsg = '';


             var retVal = false
                 if(vehicleGarageState == "CA" || vehicleGarageState == "FL" ||
                     vehicleGarageState == "DC" || vehicleGarageState == "HI"
                     || vehicleGarageState == "MA"
                      || vehicleGarageState == "NJ"
                     || vehicleGarageState == "NY" ){
                   retVal = true
                 }


             if(retVal && vehicleCovs[0].coverages.length == 0){
                var message = $filter('translate')('quoteandbind.controllers.ModalService.Attention');
                errorMsg = $filter('translate')('quoteandbind.views.quote-details.vehicleIneligibleOutOfState')+'<br>'+'<b>'+vehicleName+'</b>'+'<br><br>';
             }
             return errorMsg;
        }*/

    };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/services/ErrorHandlingService.js
 **/